export default function() {
    // Accordions
    // Used globally on mobile navigation, footer and accordion block
    // If there is an accordion inside an accordion then data-accordion-allow-multiple needs to be used
    const accordions = document.querySelectorAll('[data-accordion-link]');

    if (accordions.length) {
        accordions.forEach(function(accordion) {
            accordion.addEventListener('click', toggleAccordion);
        });
    }

    function toggleAccordion(el) {
        const link = el.target.closest('[data-accordion-link]');
        const current = link.closest('[data-accordion-item]');
        const parent = link.closest('[data-accordion]');
        const items = parent.querySelectorAll('[data-accordion-item]');

        current.classList.toggle('is-active');
        link.setAttribute('aria-expanded', link.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');

        if(!("accordionAllowMultiple" in parent.dataset)) {
            items.forEach(function(item) {
                if (item !== current) {
                    item.classList.remove('is-active');
                    item.querySelector('[data-accordion-link]').setAttribute('aria-expanded', 'false');
                }
            });
        }
    }
}